<template v-if="isLoaded.value != false">
    <BasePopup closeType="stayOnPage" width="700" @clickToClose="clickToClose">
            <header>
                <font-awesome-icon icon="fa-solid fa-pen-field" style="color: #28bc6d;"/>
                <span v-if="route.params.slug != 'new'"  class="ms-2 align-middle">Editar campo personalizado</span>
                <span v-else class="ms-2 align-middle">Novo campo personalizado</span>
            </header>
            <form @submit.prevent="">
                <div class="row">
                    <BaseInput
                        class="col-12 mb-3"
                        id="title"
                        label="Título *"
                        type="text"
                        v-model="personalized_field.title"
                        :page="route.name"
                    />
                    <BaseSelect
                        class="col-12 mb-3"
                        id="type"
                        label="Tipo "
                        :items="typeList"
                        v-model="personalized_field.type"
                        :page="route.name"
                    />
                    <BaseInput
                        class="col-12 mb-3"
                        id="slug"
                        label="Slug"
                        type="text"
                        v-model="personalized_field.slug"
                        :page="route.name"
                    />
                    <BaseSwitch
                        id="required"
                        class="col-12"
                        label='Campo obrigatório'
                        :page="route.name" 
                        v-model:checked="personalized_field.required"
                    />
                </div>
                <BaseButton @click="submit" class="btn-success w-100 mt-4">
                    Salvar
                </BaseButton>
            </form>
    </BasePopup>
</template>

<script setup>
import { computed, onBeforeMount, ref } from 'vue'
import { storeToRefs } from 'pinia';
import { useRoute, useRouter } from 'vue-router'
import { useProductStore } from "@/stores/products";
import { useGlobalStore } from '@/stores/global';

const productStore = useProductStore();
const { personalized_field }  = storeToRefs(productStore); 
const globalStore = useGlobalStore();

const route = useRoute();
const router = useRouter();

const isLoaded = ref(false)

const product_id = computed (function () {
    return route.params.id;
});

const typeList = ref({
    'text': 'Texto',
    'date': 'Data',
    'date_period': 'Período de datas',
    'hour': 'Horario',
    'cpf': 'CPF',
    'cnpj': 'CNPJ',
    'rg': 'RG',
    'email': 'E-mail',
})

onBeforeMount(() =>{
    delete globalStore.errors[route.name];
    if(route.params.slug != 'new'){
        if(productStore.personalized_field.id == undefined){
            globalStore.loader('show')
            productStore.tryField(route.params.slug).then(() =>{
                isLoaded.value = true
                globalStore.loader('hide')
            })
        } else {
            isLoaded.value = true
        }
    }else {
        globalStore.cleanObject(productStore.personalized_field);
        isLoaded.value = true
    }
})

let previousPage = router.options.history.state.back;

function clickToClose() {
    router.push(previousPage)
}

function submit(){
    globalStore.loader('show')
    if(route.params.slug != 'new'){
        let params = ['title', 'type', 'slug', 'required'];

        productStore.tryUpdateField(route.params.slug, params, route.name).then(function(success) {
            if(success){
                productStore.tryFields().then(function(){
                    globalStore.loader('hide');
                    router.push('/products/' + product_id.value + '/custom-fields')
                })
            }
        });
    } else {
        let params = ['title', 'type', 'slug', 'required'];

        productStore.tryCreateField(params, route.name).then(function(success){
            if(success){
                productStore.tryFields().then(function() {
                    globalStore.loader('hide');
                    router.push('/products/' + product_id.value + '/custom-fields')
                });
            }else {
                globalStore.loader('hide');
            }
        })
    }
}

</script>